import React from "react";
import "./Offering.css";

const plans = [
  {
    title: "Monthly Plan",
    price: 39,
    period: "/ month",
    trial: "15-Day Free Trial",
    features: [
      "2 hours of expert training",
      "Support via email or phone",
      "24/7 technical support",
    ],
  },
  {
    title: "Annual Plan",
    price: 399,
    period: "/ year",
    trial: "15-Day Free Trial",
    features: [
      "6 hours of expert training",
      "Priority support via phone and email",
      "In-person training session",
      "24/7 technical support",
    ],
  },
];

const Offering: React.FC = () => {
  return (
    <section className="offering">
      <div className="container">
        <h2 className="offering-title">RCOVR Offering</h2>
        <p className="offering-subtitle">
          Choose the plan that fits your needs and get started with immersive VRET solutions.
        </p>

        <div className="offering-cards">
          {plans.map((plan) => (
            <div className="offering-card" key={plan.title}>
              <div className="plan-header">
                <h3>{plan.title}</h3>
                <span className="trial-badge">{plan.trial}</span>
              </div>

              <p className="price">
                ${plan.price} <span>{plan.period}</span>
              </p>

              <div className="limited-offer">Limited Time Offer</div>

              <div className="card-content">
                <div className="features-list">
                  {plan.features.map((feature, index) => (
                    <span key={index}>{feature}</span>
                  ))}
                </div>
                <button
  className="demo-btn"
  onClick={() =>
    window.open(
      "https://www.meta.com/en-gb/experiences/rcovr/7420600594637803/",
      "_blank"
    )
  }
>
  Subscribe Now
</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Offering;
